import styled from 'styled-components';
import { ContentBoundary } from 'styles/CommonStyles';

const PageBody = styled.main`
  padding-top: 4rem;
  ${ContentBoundary};
`;

export default PageBody;
